import { atomWithReset } from 'jotai/utils';
import { focusAtom } from 'jotai/optics';
import { SpaceshipApiError } from '../utils/helpers';
import { CouponError } from '../types/common';

export type ErrorMessage = SpaceshipApiError | CouponError;
interface Message {
  success: string | null | undefined;
  error: ErrorMessage | null | undefined;
}

const initMsgState: Message = {
  success: null,
  error: null,
};

export const messageAtom = atomWithReset(initMsgState);

export const successAtom = focusAtom(messageAtom, (optic) => optic.prop('success'));

export const errorAtom = focusAtom(messageAtom, (optic) => optic.prop('error'));
